import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router } from '@angular/router';
import { CustomRouteData } from '@modules/common/models/custom-route-data';
import { AuthenticationTokenService } from '@modules/common/services/authentication-token.service';
import { PermissionService } from '@modules/common/services/permission.service';
import { RedirectToLoginService } from '@modules/common/services/redirect-to-login.service';

@Injectable({
    providedIn: 'root'
})
export class RouteGuardService implements CanActivate, CanActivateChild {
    constructor(
        private _authenticationTokenService: AuthenticationTokenService,
        private _redirectToLoginService: RedirectToLoginService,
        private _permissionService: PermissionService,
        private _router: Router
    ) { }

    public canActivate(route: ActivatedRouteSnapshot): boolean {
        if (!this._authenticationTokenService.hasValidAuthenticationToken()) {
            this._redirectToLoginService.redirectToLogin(route);
            return false;
        }

        const customRouteData = route.data as CustomRouteData | undefined;
        if (customRouteData && customRouteData.requiredPermissions && customRouteData.requiredPermissions.length && !customRouteData.requiredPermissions.some(x => this._permissionService.verifyPermission(x))) {
            this._router.navigate(['/']);
            return false;
        }

        return true;
    }

    public canActivateChild(route: ActivatedRouteSnapshot): boolean {
        return this.canActivate(route);
    }
}
